import React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import ExamRoomInput from "./ExamRoomInput";

const SessionExamRooms = () => {
  return (
    <Card sx={{ width: "100%", mb: 2 }}>
      <CardContent>
        <Grid
          container
          spacing={1}
        >
          <Typography
            fontWeight="bold"
            color="primary"
          >
            Зала за провеждане на изпит
          </Typography>
        </Grid>

        <ExamRoomInput />
      </CardContent>
    </Card>
  );
};

export default SessionExamRooms;
